var thisYear = (new Date).getFullYear();
var thisMonth = (new Date).getMonth();
var CALENDAR_INPUT;
var dataForShifttBtn = [
    {
        year: thisYear,
        month: thisMonth,
        countMonth: 1
    },
    {
        year: thisYear,
        month: thisMonth,
        countMonth: 3
    },
    {
        year: thisYear,
        month: thisMonth,
        countMonth: 6
    },
    {
        year: thisYear,
        month: thisMonth,
        countMonth: 12
    }
];

var CANDIDATE = "Candidate",
    EMPLOYER = "Employer";

var thisGroupCalendarID = "",
    thisUserID = "",
    thisCalendarID = "",
    thisCalendarType = "",
    thisCalendarEdit = "",
    thisCalendarStyle = CANDIDATE,
    thisValueID = [],
    sample_obj = [];

var selected_date = $('.ui-selected'),
    flag_month = false,
    flag_week = false,
    flag_two_weeks = false,
    flag_day = false;

function ev() {
    $('.context-menu-one .box-date-candidate').contextmenu(function (e) {
        getSelectType(thisCalendarType)
        $(this).find('.select-border').addClass("ui-selected");
    });
}


function addEventOnCalendar() {
    $(".group-calendar").on("click", function (e) {
        var target = $(e.target);
        thisGroupCalendarID = $(this).attr("id");
        if (target.hasClass("btn_prev") || target.hasClass("fa-chevron-left")) {
            // getThisInfo();
            prevDate(thisCalendarType);
            ev();
        } else if (target.hasClass("btn_next") || target.hasClass("fa-chevron-right")) {
            // getThisInfo();
            nextDate(thisCalendarType);
            ev();
        } else if (target.hasClass("target-month")) {
            e.preventDefault();
            target.tab("show");
            nameTab = target.attr('href');
            // getThisInfo();
            // getSelectType(thisCalendarType);
            // CreateCalendar(thisYear, thisMonth, thisCalendarID, thisCalendarType, thisCalendarStyle);

            // ev();
            init(thisYear, thisMonth);
            setActiveClass();
            ev();
        };
    });

    ev();

}
addEventOnCalendar();

isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

var prev = -1;
$(".boxCalendar").selectable({filter: '.select-border'},
    {

        start: function (event, ui) {
            thisCalendarID_old = thisCalendarID;
            // getThisInfo();
            if (thisCalendarID != thisCalendarID_old) {
                selected_date.each(function (index) {
                    selected_date[index].data = $(this).attr('id');
                    $(this).removeClass("ui-selected");
                });
            }
        }
    },
    {
        selecting: function (e, ui) {
            var curr = $(ui.selecting.tagName, e.target).index(ui.selecting);
            thisCalendarID_old = thisCalendarID;
            if (e.shiftKey && prev > -1) {
                $(ui.selecting.tagName, e.target).slice(Math.min(prev - 1, curr), 1 + Math.max(prev, curr)).find(".select-border").addClass('ui-selected');
                // getThisInfo();
                if (thisCalendarID != thisCalendarID_old) {
                    selected_date.each(function (index) {
                        selected_date[index].data = $(this).attr('id');
                        $(this).removeClass("ui-selected");
                    });
                }
            } else {
                prev = curr;
                if (thisCalendarID != thisCalendarID_old) {
                    selected_date.each(function (index) {
                        selected_date[index].data = $(this).attr('id');
                        $(this).removeClass("ui-selected");
                    });
                }
            }
        }
    },
    {
        stop: function (event, ui) {
            selected_date = $('.ui-selected');

            // selected_date.find(".select-border").addClass("ui-selected");
            // console.log(selected_date)
            getSelectType(thisCalendarType);
if($(".CreateCalendar .ui-selectee").hasClass("ui-selected")){
    if (isMobile.any()) {
        var offset =$(".CreateCalendar .ui-selectee.ui-selected").last().offset();
        $("ul.context-menu-list.context-menu-root").css({"left": offset.left+30, "top": offset.top+20, "width": "183px", "z-index": "1","display": "block"});
    }
}
        }
    }
);

function findIndex(thisCalendarType) {
    if (thisCalendarType == "day")
        return 0;
    if (thisCalendarType == "week")
        return 1;
    if (thisCalendarType == "two-weeks")
        return 2;
    if (thisCalendarType == "month")
        return 3;
}

function nextDate(thisCalendarType) {
    var currentMonth, currentYear, index;
    index = findIndex(thisCalendarType);
    dataForShifttBtn[index].month += dataForShifttBtn[index].countMonth;
    if (dataForShifttBtn[index].month >= 12) {
        dataForShifttBtn[index].month = dataForShifttBtn[index].month - 12;
        dataForShifttBtn[index].year++;
    }
    currentMonth = dataForShifttBtn[index].month;
    currentYear = dataForShifttBtn[index].year;
    thisMonth=currentMonth;

    // CreateCalendar(currentYear, currentMonth, thisCalendarID, thisCalendarType, thisCalendarStyle);
    init(currentYear, currentMonth);
}

function prevDate(thisCalendarType) {
    var currentMonth, currentYear, index;
    index = findIndex(thisCalendarType);
    dataForShifttBtn[index].month -= dataForShifttBtn[index].countMonth;
    if (dataForShifttBtn[index].month < 0) {
        dataForShifttBtn[index].month = 12 + dataForShifttBtn[index].month;
        dataForShifttBtn[index].year--;
    }
    currentMonth = dataForShifttBtn[index].month;
    currentYear = dataForShifttBtn[index].year;
    thisMonth=currentMonth;
    // CreateCalendar(currentYear, currentMonth, thisCalendarID, thisCalendarType, thisCalendarStyle);
    init(currentYear, currentMonth);
}

function inComingDate(Date) {
    var separator = "-",
        tmp = Date.split(separator);
    month = parseInt(tmp[1]) - 1;

    strDate = tmp[0] + separator + month + separator + tmp[2];

    return strDate;
}

function outComingDate(Date) {
    var separator = "-",
        tmp = Date.split(separator);
    month = parseInt(tmp[1]) + 1;

    if (month < 10) {
        month = "0" + month;
    }

    strDate = tmp[0] + separator + month + separator + tmp[2];
    return strDate;
}

function getSelectType(CalendarType) {
    if (CalendarType == "day") {
        flag_day = true;
        flag_week = false;
        flag_two_weeks = false;
        flag_month = false;
        thisCalendarType = "day";
    }
    if (CalendarType == "week") {
        flag_day = false;
        flag_week = true;
        flag_two_weeks = false;
        flag_month = false;
        thisCalendarType = "week";
    }
    if (CalendarType == "two-weeks") {
        flag_day = false;
        flag_week = false;
        flag_two_weeks = true;
        flag_month = false;
        thisCalendarType = "two-weeks";
    }
    if (CalendarType == "month") {
        flag_day = false;
        flag_week = false;
        flag_two_weeks = false;
        flag_month = true;
        thisCalendarType = "month";
    }
}

function setActiveClass() {

    // Делает выбранную вкладку активной
    selectorBtnTab = "#" + thisGroupCalendarID + " .btn-group a";
    $(selectorBtnTab).removeClass("active");
    selectorTab = "a[href$='" + nameTab + "']";
    $(selectorTab).addClass("active");
}

function setStatusEdit() {
    // Устанавливает data-edit и data-styleCalendar параметрами из value=JSON
    allInput = $(".withCalendar .infoDate:not(.isRender)");

    for (i = 0; i < allInput.length; i++) {
        allInput.eq(i).addClass("isRender");
        try {
            inputID = "#" + allInput[i].id;
            strJSON = $(inputID).val();
            objValue = JSON.parse(strJSON);
        }
        catch (err) {
            continue
        }

        statusEdit = objValue[0].Edit;
        styleCalendar = objValue[0].typeCalendar;
        tmpSelGrCalID = $(inputID).parents(".group-calendar").attr("id");
        selGrCalID = "#" + tmpSelGrCalID;

        if (statusEdit == "disabled") {
            selectorContextMenu = $(selGrCalID + " .context-menu-one");
            $(selectorContextMenu).addClass("context-menu-disabled");

            groupCalendar = document.getElementById(tmpSelGrCalID);
            groupCalendar.setAttribute('data-edit', 'disabled');
        }
        else {
            groupCalendar = document.getElementById(tmpSelGrCalID);
            groupCalendar.setAttribute('data-edit', 'enabled');
        }


        if (styleCalendar == CANDIDATE || styleCalendar == "") {
            groupCalendar = document.getElementById(tmpSelGrCalID);
            groupCalendar.setAttribute('data-styleCalendar', CANDIDATE);

        }
        if (styleCalendar == EMPLOYER) {
            groupCalendar = document.getElementById(tmpSelGrCalID);
            groupCalendar.setAttribute('data-styleCalendar', EMPLOYER);
        }
    }

}

function getValue(idUser) {
    tmp = idUser + "";
    selectorValue = "#value_" + tmp;
    strJSON = $(selectorValue).val();

    try {
        objValue = JSON.parse(strJSON);
    }
    catch (err) {
        return [];
    }
    thisValueID = objValue[0].Data;

    if (thisValueID == undefined) {
        return thisValueID = [];
    } else {
        for (var i in thisValueID) {
            thisValueID[i].data = inComingDate(thisValueID[i].data);
        }

        return thisValueID;
    }
}

function getValueFuck(idUser) {
    tmp = idUser + "";
    selectorValue = "#value_" + tmp;
    strJSON = $(selectorValue).val();

    try {
        objValue = JSON.parse(strJSON);
    }
    catch (err) {
        return [];
    }
    thisValueID = objValue[0].Data;

    if (thisValueID == undefined) {
        return thisValueID = [];
    } else {
        return thisValueID;
    }
}

function getThisInfo() {
    tmp = thisGroupCalendarID.split("_");
    thisID = tmp[1];

    var result = {};

    result.thisUserID = thisID;
    result.thisValueID = getValue(thisID);
    sample_obj = getValueFuck(thisID);

    temp = "#" + thisGroupCalendarID + " .tab-pane.active ";
    temp = "#" + $(temp).attr("id") + " .CreateCalendar";
    result.thisCalendarID = $(temp).attr("id");
    result.thisCalendarType = $("#" + result.thisCalendarID).data("type");

    thisUserID = result.thisUserID;
    thisCalendarID = result.thisCalendarID;
    thisCalendarType = result.thisCalendarType;
    thisCalendarEdit = result.thisCalendarEdit;
    thisValueID = result.thisValueID;
    return result
}

function SaveToBD(idUser) {
    function compare(a, b) {
        var aDate = new Date(a['data']);
        var bDate = new Date(b['data']);
        if(aDate < bDate)
            return -1;
        if(aDate > bDate)
            return 1;
        return 0;
    }
    sample_obj.sort(compare);

    var send = [{
        UserId: idUser,
        Data: sample_obj
    }];


    str = JSON.stringify(send);
    valueID = "#value_" + idUser;

    $(valueID).val(str);
}

// Определяем какие календари создавать
function init(year, month) {
    var yearC,monthC;
    if(!year && !month){
         yearC=thisYear;
         monthC=thisMonth;
    }else{
        yearC=year;
        monthC=month;
    }
    setStatusEdit();
    var getAllCalendarsID = [];
    attrCalendar = $('.withCalendar .boxCalendar .CreateCalendar:not(.isRender)');
    if (attrCalendar.length != 0) {

        for (i = 0; i < attrCalendar.length; i++) {
            attrCalendar.eq(i).addClass("attrCalendar");
            idCalendar = attrCalendar[i].id;
            tmpSelGrCalID = $("#" + idCalendar).parents(".group-calendar").attr("id");
            selGrCalID = "#" + tmpSelGrCalID;
            tmp = selGrCalID.split("_");
            idUser = tmp[1];

            var info = {
                idCalendar: idCalendar,
                idUser: idUser,
                typeCalendar: attrCalendar[i].getAttribute("data-type")
            };
            getAllCalendarsID.push(info);
        }
        for (j = 0; j < getAllCalendarsID.length; j++) {

            thisUserID = getAllCalendarsID[j].idUser;
            thisCalendarID = getAllCalendarsID[j].idCalendar;
            thisCalendarType = getAllCalendarsID[j].typeCalendar;
            thisValueID = getValue(thisUserID);

            sample_obj = thisValueID;


            CreateCalendar(yearC, monthC, thisCalendarID, thisCalendarType, thisCalendarStyle);
        }

        thisGroupCalendarID = "groupCalendars-id_" + thisUserID;
        thisUserID = getAllCalendarsID[0].idUser;
        thisCalendarID = getAllCalendarsID[0].idCalendar;
        thisCalendarType = getThisInfo().thisCalendarType;
        thisCalendarEdit = getThisInfo().thisCalendarEdit;
        thisValueID = getValue(thisUserID);
    }
}

// ------------------------------------------------------

function DaysInMonth(year, month) {
    // Определяет количество дней в месяце (месяца указывать в формате 0-11)
    var data = {
            year: year,
            month: month
        },
        DaysInMonth = 0;
    DaysInMonth = moment(data).daysInMonth();

    return DaysInMonth
}

function NumberWeek(year, month, day) {
    // Определение номера недели зная год, месяц, число
    var LastDayMonth = 0,
        FirstDayMonth = 0,
        NumberWeek = "",

        dayWeek = 0,
        dayMonth = 0,
        num_Week = 0,
        DayInWeek = 0,
        flag = true,

        date = {
            year: year,
            month: month
        },
        result = {};

    DayInWeek = 8 - moment(date).format('E');
    LastDayWeek = DaysInMonth(year, month);
    while (LastDayMonth <= LastDayWeek - 1) {
        FirstDayMonth = LastDayMonth + 1;
        while (dayWeek != DayInWeek && flag == true) {
            dayWeek++;
            dayMonth++;
            LastDayMonth++;
            if (dayMonth == day) {
                NumberWeek = num_Week;
            }
            if (LastDayMonth == LastDayWeek) {
                flag = false;
            }
        }
        num_Week++;
        dayWeek = 0;
        DayInWeek = 7;
    }
    result.NumberWeek = NumberWeek;
    return result;
}

function NumberTwoWeeks(year, month, day) {
    var LastDayMonth = 0,
        FirstDayMonth = 0,
        NumberWeek = "",

        dayWeek = 0,
        dayMonth = 0,
        num_Week = 0,
        DayInWeek = 0,
        flag = true,

        date = {
            year: year,
            month: month
        },
        result = {};

    DayInWeek = 15 - moment(date).format('E');
    LastDayWeek = DaysInMonth(year, month);
    while (LastDayMonth <= LastDayWeek - 1) {
        FirstDayMonth = LastDayMonth + 1;
        while (dayWeek != DayInWeek && flag == true) {
            dayWeek++;
            dayMonth++;
            LastDayMonth++;
            if (dayMonth == day) {
                NumberWeek = num_Week;
            }
            if (LastDayMonth == LastDayWeek) {
                flag = false;
            }
        }
        num_Week++;
        dayWeek = 0;
        DayInWeek = 14;
    }
    result.NumberWeek = NumberWeek;
    return result;
}

function ParseIDtoDateWeek(string) {
    //Формат string "yyyy-m-#wk-fdW-ldW" Пример: 2016-1-1wk-8-14
    // где  #wk - номер недели
    //      fdW - FirstDayWeek
    //      ldW - LastDayWeek
    var data = string.split('-');
    var result = {
        year: data[0],
        month: data[1],
        FirstDayWeek: data[3],
        LastDayWeek: data[4]
    };

    // result.year = data[0];
    // result.month = data[1];
    // result.FirstDayWeek = data[3];
    // result.LastDayWeek = data[4];
    return result;
}

function ParseIDtoDate(string) {
    // Формат string "yyyy-m-d"
    var data = string.split('-');
    var result = {
        year: data[0],
        month: data[1],
        day: data[2]
    };
    // result.year = data[0];
    // result.month = data[1];
    // result.day = data[2];
    return result;
}

function splitMonthWeek(year, month) {
    // Разбивает месяц по недели и
    // возвращает: номер недели, количество дней в недели, первый и последний день недели
    // месяц указывать в формате 0 - 11

    var FirstDayWeek = 0,
        LastDayWeek = 0,
        NumberDaysInWeek = 0,

        countDayWeek = 0,
        flag = true,

        result = [],
        date = {
            year: year,
            month: month
        };
    NumberDaysInWeek = 8 - moment(date).format('E');
    LastDayMonth = DaysInMonth(year, month);
    while (LastDayWeek <= LastDayMonth - 1) {
        FirstDayWeek = LastDayWeek + 1;
        while (countDayWeek != NumberDaysInWeek && flag == true) {
            countDayWeek++;
            LastDayWeek++;
            if (LastDayWeek == LastDayMonth) {
                flag = false;
                NumberDaysInWeek = countDayWeek;
            }
        }
        result.push(
            {
                FirstDayWeek: FirstDayWeek,
                LastDayWeek: LastDayWeek,
                NumberDayWeek: NumberDaysInWeek
            });
        countDayWeek = 0;
        NumberDaysInWeek = 7;
    }

    return result;
}

function splitMonthTwoWeeks(year, month) {
    // Разбивает месяц по недели и
    // возвращает: номер недели, количество дней в недели, первый и последний день недели
    // месяц указывать в формате 0 - 11

    var FirstDayWeek = 0,
        LastDayWeek = 0,
        NumberDaysInWeek = 0,

        countDayWeek = 0,
        flag = true,

        result = [],
        date = {
            year: year,
            month: month
        };

    NumberDaysInWeek = 15 - moment(date).format('E');
    LastDayMonth = DaysInMonth(year, month);
    while (LastDayWeek <= LastDayMonth - 1) {
        FirstDayWeek = LastDayWeek + 1;
        while (countDayWeek != NumberDaysInWeek && flag == true) {
            countDayWeek++;
            LastDayWeek++;
            if (LastDayWeek == LastDayMonth) {
                flag = false;
                NumberDaysInWeek = countDayWeek;
            }
        }
        result.push(
            {
                FirstDayWeek: FirstDayWeek,
                LastDayWeek: LastDayWeek,
                NumberDayWeek: NumberDaysInWeek
            });
        countDayWeek = 0;
        NumberDaysInWeek = 14;
    }
    return result;
}

function getStatusMonth(year, month) {
    // функци возвращают статус месяца, недели, дня соответственно
    var found = 0,
        LastDayMonth = 0,
        EmentsFind = [],
        result = {
            status: ""
        };

    // Делаем парс всех дат и добавляем в массив allelements
    for (var i in sample_obj) {
        year_str = ParseIDtoDateWeek(sample_obj[i].data).year;
        month_str = ParseIDtoDateWeek(sample_obj[i].data).month;
        status_str = sample_obj[i].status;
        EmentsFind [i] = year_str + "-" + month_str + "-" + status_str;
    }

    var StatusDate = ["red", "green", "orange"];

    LastDayMonth = DaysInMonth(year, month);

    for (itemStatus = 0; itemStatus < 3; itemStatus++) {
        strDate = year + "-" + month + "-" + StatusDate[itemStatus];


        for (var i = 0; i < EmentsFind.length; i++) {

            if (EmentsFind[i] == strDate) {
                found = found + 1;
            }
        }
        if (LastDayMonth == found) {
            result.status = StatusDate[itemStatus];
        }
        found = 0;
    }

    return result;
}

function getStatusWeek(year, month, week) {
    var found = 0,
        EmentsFinds = [],
        result = {
            status: ""
        };

    // Делаем парс всех дат и добавляем в массив allelements
    for (var i in sample_obj) {
        year_str = ParseIDtoDate(sample_obj[i].data).year;
        month_str = ParseIDtoDate(sample_obj[i].data).month;
        day_str = ParseIDtoDate(sample_obj[i].data).day;
        week_str = NumberWeek(year_str, month_str, day_str).NumberWeek;
        status_str = sample_obj[i].status;
        EmentsFinds [i] = year_str + "-" + month_str + "-" + week_str + "-" + status_str;
    }

    var StatusDate = ["red", "green", "orange"];

    for (itemStatus = 0; itemStatus < 3; itemStatus++) {
        strDate = year + "-" + month + "-" + week + "-" + StatusDate[itemStatus];
        for (var i = 0; i < EmentsFinds.length; i++) {
            if (EmentsFinds[i] == strDate) {
                found = found + 1;
            }
        }
        NumberDayWeek = splitMonthWeek(year, month)[week].NumberDayWeek;

        if (found == NumberDayWeek) {
            result.status = StatusDate[itemStatus];
        }
        found = 0;
    }
    return result;
}

function getStatusTwoWeeks(year, month, week) {
    var found = 0,
        EmentsFinds = [],
        result = {
            status: ""
        };

    // Делаем парс всех дат и добавляем в массив allelements
    for (var i in sample_obj) {
        year_str = ParseIDtoDate(sample_obj[i].data).year;
        month_str = ParseIDtoDate(sample_obj[i].data).month;
        day_str = ParseIDtoDate(sample_obj[i].data).day;
        week_str = NumberTwoWeeks(year_str, month_str, day_str).NumberWeek;
        status_str = sample_obj[i].status;
        EmentsFinds [i] = year_str + "-" + month_str + "-" + week_str + "-" + status_str;
    }

    var StatusDate = ["red", "green", "orange"];

    for (itemStatus = 0; itemStatus < 3; itemStatus++) {
        strDate = year + "-" + month + "-" + week + "-" + StatusDate[itemStatus];
        for (var i = 0; i < EmentsFinds.length; i++) {
            if (EmentsFinds[i] == strDate) {
                found = found + 1;
            }
        }
        NumberDayWeek = splitMonthTwoWeeks(year, month)[week].NumberDayWeek;

        if (found == NumberDayWeek) {
            result.status = StatusDate[itemStatus];
        }
        found = 0;
    }
    return result;
}

function getStatusDay(date) {
    var result = {
        status: ""
    };

    for (var i in sample_obj) {
        if (date == sample_obj[i].data) {
            result.status = sample_obj[i].status;
        }
    }
    return result;

}

function updateStatusDates(color, op) {
    // Устанавливает и выводит статус (цвет) выбранных дат (месяцев, недель, дней и записываем в sample_obj
    var selected_temp = [];

    // Функция обновляет sample_obj данными из selected_temp
    function updateDate() {
        for (i = 0; i < selected_temp.length; i++) {
            selected_temp[i].data = outComingDate(selected_temp[i].data);
            isAdd = false;
            for (var j in sample_obj) {
                if (sample_obj[j].data == selected_temp[i].data) {

                    sample_obj[j] = selected_temp[i];
                    isAdd = true;
                    break;
                }
            }

            if (isAdd == false){
                sample_obj.push(selected_temp[i]);
            }
        }
        ev();
    }

    if (flag_day == false && flag_month == false && flag_week == false && flag_two_weeks == false) {
        alert("Дата не выбрана");

    } else {
        selected_date = $('.ui-selected');
        // Изменяет цвет выбранных дат на выбранный цвет
        selected_date.each(function (index) {
            selected_date[index].data = $(this).attr('id');

            $(this).removeClass("ui-selected");
            $(this).removeClass("red");
            $(this).removeClass("green");
            $(this).removeClass("orange");
            // $(this).removeClass("gray");

            $(this).addClass(color);

            selected_date[index].status = color;
        });

        // Преобразовываем массив selected_date в selected_temp
        selected_date.each(function (i, item) {
            var info = {
                data: item.firstChild.id,
                status: color
            };
            selected_temp.push(info);

        });

        if (flag_day == true) {
            updateDate();
            flag_day = false;
        }

        if (flag_month == true) {
            //-------------- Создаем все дни месяца ----------------
            var DaysMonth = [],
                YearMonth = "";
            for (var i in selected_temp) {
                YearMonth = selected_temp[i].data + "-";
                year = ParseIDtoDateWeek(selected_temp[i].data).year;
                month = ParseIDtoDateWeek(selected_temp[i].data).month;
                LastDayMonth = DaysInMonth(year, month);

                for (Day = 1; Day < LastDayMonth + 1; Day++) {
                    var info_day = {
                        data: YearMonth + Day,
                        status: color
                    };
                    DaysMonth.push(info_day)
                }
            }
            selected_temp = DaysMonth;
            updateDate();
            flag_month = false;
        }

        if (flag_week == true) {
            //-------------- Создаем все дни недели ---------------
            var DaysWeek = [],
                data = "";

            for (var i in selected_temp) {
                year = ParseIDtoDateWeek(selected_temp[i].data).year;
                month = ParseIDtoDateWeek(selected_temp[i].data).month;
                FirstDayWeek = parseInt(ParseIDtoDateWeek(selected_temp[i].data).FirstDayWeek);
                LastDayWeek = parseInt(ParseIDtoDateWeek(selected_temp[i].data).LastDayWeek);

                for (Day = FirstDayWeek; Day < LastDayWeek + 1; Day++) {
                    if (Day < 10) {
                        data = year + "-" + month + "-0" + Day;
                    } else {
                        data = year + "-" + month + "-" + Day;
                    }
                    var info_day = {
                        data: data,
                        status: color
                    };
                    DaysWeek.push(info_day)
                }
            }
            selected_temp = DaysWeek;
            updateDate();
            flag_week = false;
        }


        if (flag_two_weeks == true) {
            //-------------- Создаем все дни недели ---------------
            var DaysTwoWeek = [],
                data = "";
            for (var i in selected_temp) {
                year = ParseIDtoDateWeek(selected_temp[i].data).year;
                month = ParseIDtoDateWeek(selected_temp[i].data).month;
                FirstDayWeek = parseInt(ParseIDtoDateWeek(selected_temp[i].data).FirstDayWeek);
                LastDayWeek = parseInt(ParseIDtoDateWeek(selected_temp[i].data).LastDayWeek);

                for (Day = FirstDayWeek; Day < LastDayWeek + 1; Day++) {
                    if (Day < 10) {
                        data = year + "-" + month + "-0" + Day;
                    } else {
                        data = year + "-" + month + "-" + Day;
                    }
                    var info_day = {
                        data: data,
                        status: color
                    };
                    DaysTwoWeek.push(info_day)
                }
            }
            selected_temp = DaysTwoWeek;

            updateDate();
            flag_two_weeks = false;
        }
        // Удаляем все объекты со статусом , gray
        send_obj = [];

        for (var i in sample_obj) {
            // sample_obj[i].data = outComingDate(sample_obj[i].data);

            //для проекта
            if ($(".bl-calendar").hasClass('launchNewProjectCalendar')) {
                if (sample_obj[i].status != "red"
                    &&
                    sample_obj[i].status != "gray") {
                    send_obj.push(sample_obj[i]);
                }
            } else {
                //для кандидата
                if (sample_obj[i].status != "green"
                    &&
                    sample_obj[i].status != "gray") {
                    send_obj.push(sample_obj[i]);
                }
            }
        }
        sample_obj = send_obj;

        if (thisCalendarEdit != "disabled") {
            SaveToBD(thisUserID);

            CALENDAR_INPUT = $(".infoDate ").val();
        }
    }
}

function CreateCalendar(yyyy, mm, idCalendar, typeCalendar, forCalendar) {
    function CreateBoxDate(day, idDate, markerClass, nameClass, styleCalendar) {
        if (styleCalendar == CANDIDATE) {
            styleBoxDate = "box-date-candidate"
        } else {
            styleBoxDate = "box-date-employer"
        }
        boxDate = '<div class="' + styleBoxDate + '">' +
            '<div class="select-border ' + markerClass + '">' +
            '<div ' + 'id="' + idDate + '" class="' + nameClass + '">' +
            day + "</div></div></div>";
        return boxDate;
    }

    function CreateBoxTitle(yyyy, mm, boxMonth) {
        var date = {
            year: yyyy,
            month: mm
        };
        nameMonnth = moment(date).format("MMMM YYYY");
        TitleMonth = '<div class="title-date ">' + nameMonnth + '</div>';
        span_mon = "<span " + 'class="' + "span_" + typeCalendar + '">' + TitleMonth + boxMonth + "</span>";

        return span_mon;
    }

    var boxCalendar = document.getElementById(idCalendar),

        date = {
            year: yyyy,
            month: mm
        },
        month = mm,
        styleCalendar = forCalendar;

    boxCalendarTmp = "",
        boxMonth = "",
        span_mon = "";

    if (typeCalendar == "day") {
        LastDayMonth = DaysInMonth(thisYear, thisMonth);

        for (day = 1; day < LastDayMonth + 1; day++) {
            if (day < 10) {
                idDate = yyyy + "-" + mm + "-0" + day;
            } else {
                idDate = yyyy + "-" + mm + "-" + day;
            }

            marker_class = getStatusDay(idDate).status;

            boxMonth += CreateBoxDate(day, idDate, marker_class, "day", styleCalendar);
        }
        boxCalendarTmp = CreateBoxTitle(yyyy, mm, boxMonth);
    }

    if (typeCalendar == "week") {
        var month = mm;
        var year = yyyy;
        for (var iq = 0; iq < 3; iq++) {
            if (month > 11) {
                month = 0;
                year++
            }

            var boxWeek = "",
                MonthWeek = [],
                date = {
                    year: year,
                    month: month
                };

            MonthWeek = splitMonthWeek(year, month);

            for (var i = 0; i < MonthWeek.length; i++) {
                idWeek = yyyy + "-" + month + "-" + i + "wk" + "-" + MonthWeek[i].FirstDayWeek + "-" + MonthWeek[i].LastDayWeek;
                marker_class = getStatusWeek(year, month, i).status;

                FirstDayWeek = MonthWeek[i].FirstDayWeek;
                LastDayWeek = MonthWeek[i].LastDayWeek;
                if (FirstDayWeek == LastDayWeek) {
                    boxDate = FirstDayWeek;
                }
                else {
                    boxDate = FirstDayWeek + "-" + LastDayWeek;
                }

                boxWeek += CreateBoxDate(boxDate, idWeek, marker_class, "week", styleCalendar);
            }
            boxCalendarTmp += CreateBoxTitle(year, month, boxWeek);
            month++
        }

    }
    if (typeCalendar == "two-weeks") {
        var month = mm;
        var year = yyyy;


        for (var iq = 0; iq < 6; iq++) {
            if (month > 11) {
                month = 0;
                year++
            }
            boxWeek = "";
            MonthWeek = [];
            date = {
                year: year,
                month: month
            };

            MonthWeek = splitMonthTwoWeeks(year, month);

            for (i = 0; i < MonthWeek.length; i++) {
                idWeek = year + "-" + month + "-" + i + "two_wk" + "-" + MonthWeek[i].FirstDayWeek + "-" + MonthWeek[i].LastDayWeek;
                marker_class = getStatusTwoWeeks(year, month, i).status;

                FirstDayWeek = MonthWeek[i].FirstDayWeek;
                LastDayWeek = MonthWeek[i].LastDayWeek;
                if (FirstDayWeek == LastDayWeek) {
                    boxDate = FirstDayWeek;
                }
                else {
                    boxDate = FirstDayWeek + "-" + LastDayWeek;
                }

                boxWeek += CreateBoxDate(boxDate, idWeek, marker_class, "two-weeks", styleCalendar);
            }

            boxCalendarTmp += CreateBoxTitle(year, month, boxWeek);

            month++;
        }
    }
    if (typeCalendar == "month") {
        LastDayMonth = 0;
        date = {
            year: yyyy,
            month: 0
        };

        for (i = 0; i < 12; i++) {
            LastDayMonth = DaysInMonth(yyyy, i);
            idMonth = yyyy + "-" + i;
            marker_class = getStatusMonth(yyyy, i).status;
            boxDate = "1" + "-" + LastDayMonth;

            boxMonth = CreateBoxDate(boxDate, idMonth, marker_class, "month", styleCalendar);

            date.month = i;

            nameMonnth = moment(date).format("MMM.YYYY");
            TitleMonth = '<div class="title-date-year">' + nameMonnth + '</div>';
            span_mon = "<span class='span_month'>" + TitleMonth + boxMonth + "</span>";
            boxCalendarTmp += span_mon;
        }
    }
    boxCalendar.innerHTML = boxCalendarTmp;
}


init(thisYear, thisMonth);


